import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useUserCommentHttp } from '@/core/api/user-comments'
import { UserComment, UserCommentPayload } from '@/core/models/user-comment'

export type UserCommentCollection = {
    data: Array<UserComment>,
    meta?: MetaPayload,
    links?: any
}

const state: UserCommentCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const userCommentCollection: Module<UserCommentCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: UserCommentCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: UserCommentPayload) => {
                state.data.push(new UserComment(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useUserCommentHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: UserCommentCollection): UserCommentCollection => {
            return state
        }
    }
}